<template>
  <div @click.stop="toggle" v-if="is_del">
    <div class="top" :class="{ resetOne: level > 0 }">
      <div class="list">
        <div class="title" :style="{ paddingLeft: paddingLeft }">
          <!-- :style="{ visibility: !obj.sub || obj.sub.length <= 0 ? 'visible' : 'hidden'}" -->
          <v-icon
            class="icon material-icons mr-2"
            :class="{ transformIcon: showChildren }"
            :style="{
              visibility:
                obj.children && obj.children.length > 0 ? 'visible' : 'hidden',
            }"
            >arrow_drop_down</v-icon
          >
          <div class="title_name">{{ INT(obj.menu_name) }}</div>
        </div>
        <div class="iconlist">
          <!-- <v-icon>mdi-close</v-icon>
          <v-icon>mdi-close</v-icon>
          <v-icon>mdi-close</v-icon>
          <v-icon>mdi-close</v-icon> -->
          <mrc_ess_showClientType
            :iconList="obj.clientType"
          ></mrc_ess_showClientType>
        </div>
        <div class="func_name">{{ INT(obj.menu_name) }}</div>
        <div class="is_show">
          <!-- <span class="status"
                :class="{'is_used': !obj.is_show}">{{obj.is_show ? $t('label_show') : $t('label_hidden') }}</span> -->
          <mrc_ess_viewbtn :is_used="obj.is_show"></mrc_ess_viewbtn>
        </div>
        <div class="action">
          <menu-list :list="list" @handleClick="handleClick">
            <template v-slot:showAction>
              <v-icon v-btnAuth="['edit-menu', 'delete-menu', 'view-menu']"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
        </div>
      </div>
      <div v-if="showChildren">
        <menu-list-manage
          v-for="(item, index) in obj.children"
          :key="index"
          :obj="item"
          @delData="delData"
          :level="level + 1"
        ></menu-list-manage>
      </div>
    </div>
  </div>
</template>

<script>
import { del_menu, get_menuList } from "@/service/api/menu";
export default {
  name: "menuListManage",
  components: {},
  props: {
    level: {
      type: Number,
      default: 0,
    },
    obj: {
      type: Object,
    },
  },
  data() {
    return {
      is_del: true,
      showChildren: false,
    };
  },
  computed: {
    paddingLeft() {
      return this.level * 15 + "px";
    },
    list() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-menu"),
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-menu"),
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-menu"),
        },
      ];
    },
  },
  created() {},
  mounted() {},
  methods: {
    toggle() {
      if (this.obj.children.length <= 0) {
        return;
      }
      this.showChildren = !this.showChildren;
    },
    delData(uuid) {
      this.$emit("delData", uuid);
    },
    handleClick({ index }) {
      switch (index) {
        case 0:
          this.$store.commit("set_subPage_name", this.obj.menu_name);
          this.$store.commit("set_uuid", this.obj.uuid);
          this.$store.commit("set_iconstatus", true);
          this.$router.push({
            name: "menu_detail",
            params: {
              name: this.obj.menu_name,
              uuid: this.obj.uuid,
            },
          });
          break;
        case 1:
          this.$store.commit("set_subPage_name", this.obj.menu_name);
          this.$store.commit("set_uuid", this.obj.uuid);
          this.$store.commit("set_iconstatus", false);
          this.$router.push({
            name: "menu_detail",
            params: {
              name: this.obj.menu_name,
              uuid: this.obj.uuid,
            },
          });
          break;
        case 2:
          this.$myConfirm({
            content: "确定删除吗？",
          })
            .then(async () => {
              const del = await del_menu({ uuid: this.obj.uuid });
              if (del.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                this.is_del = false;
                this.$emit("delData", this.obj.uuid);
              }
            })
            .catch(() => {
              // console.log('点了取消')
            });
          break;
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.top {
  width: 100%;
  border: 1px solid #dedede;
  border-radius: 8px;
  margin: 10px 0;
}
.list {
  padding: 12px;
  display: flex;
  align-items: center;
}
.list:hover {
  background-color: #ececec;
}
.title {
  display: flex;
  align-items: center;
  width: 23vw;
}
.iconlist {
  width: 14vw;
  font-size: 15px;
}
.func_name {
  width: 19vw;
}
.is_show {
  flex: 1;
}
.action {
  width: 2vw;
  text-align: right;
  cursor: pointer;
}
.title_name {
  font-size: 14px;
}
.icon {
  transform: rotate(-90deg);
}

.transformIcon {
  transform: rotate(0deg);
}

.d-flex {
  align-items: center;
  font-size: 17px;
}
.resetOne {
  border: none;
  border-top: 1px solid #dedede;
  /* border-bottom: 1px solid #dedede; */
  border-radius: 0px;
  margin: 0;
}
</style>
